export default __webpack_public_path__ + "static/media/excel-logo.d9da286a.svg";